export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-red-50">
      <nav className="bg-gradient-to-r from-red-900 via-red-800 to-amber-900 shadow-lg border-b-4 border-amber-600">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <a href="/" className="flex items-center space-x-3 cursor-pointer">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center border-2 border-amber-600">
                <i className="ri-quill-pen-line text-2xl text-red-900 w-6 h-6 flex items-center justify-center"></i>
              </div>
              <div>
                <div className="text-amber-100 text-2xl font-black tracking-wider" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                  合同会社SASAICHI
                </div>
                <div className="text-amber-300 text-xs tracking-widest" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
                  Web Contents Creation
                </div>
              </div>
            </a>
            <a
              href="/"
              className="px-6 py-2 bg-amber-600 text-red-900 font-black rounded-lg hover:bg-amber-500 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
              style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}
            >
              ホームに戻る
            </a>
          </div>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 lg:px-8 py-20">
        <div className="bg-white rounded-3xl p-10 md:p-16 shadow-2xl border-4 border-red-900/20">
          <h1 className="text-5xl font-black text-red-900 mb-8 text-center" style={{ fontFamily: '"Shippori Mincho", serif' }}>
            プライバシーポリシー
          </h1>

          <div className="space-y-8 text-stone-700" style={{ fontFamily: '"Zen Kaku Gothic New", sans-serif' }}>
            <section>
              <p className="leading-relaxed font-bold">
                合同会社SASAICHI（以下、「当社」といいます。）は、お客様の個人情報の保護を重要な責務と考え、以下のプライバシーポリシーを定め、適切な取り扱いと保護に努めます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-black text-red-900 mb-4 border-l-4 border-amber-600 pl-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                1. 個人情報の定義
              </h2>
              <p className="leading-relaxed font-bold">
                個人情報とは、お客様個人に関する情報であって、氏名、生年月日、住所、電話番号、メールアドレスなど、特定の個人を識別できる情報をいいます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-black text-red-900 mb-4 border-l-4 border-amber-600 pl-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                2. 個人情報の収集方法
              </h2>
              <p className="leading-relaxed mb-3 font-bold">
                当社は、以下の方法により個人情報を収集します。
              </p>
              <ul className="list-disc list-inside space-y-2 pl-4 font-bold">
                <li>お問い合わせフォームからのご入力</li>
                <li>サービスのお申し込み時のご入力</li>
                <li>メールや電話でのお問い合わせ</li>
                <li>その他、当社が提供するサービスのご利用時</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-black text-red-900 mb-4 border-l-4 border-amber-600 pl-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                3. 個人情報の利用目的
              </h2>
              <p className="leading-relaxed mb-3 font-bold">
                当社は、収集した個人情報を以下の目的で利用します。
              </p>
              <ul className="list-disc list-inside space-y-2 pl-4 font-bold">
                <li>お問い合わせへの対応</li>
                <li>サービスの提供・運営</li>
                <li>サービスに関する情報のご案内</li>
                <li>お客様からのご意見・ご要望への対応</li>
                <li>サービスの改善・新サービスの開発</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-black text-red-900 mb-4 border-l-4 border-amber-600 pl-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                4. 個人情報の第三者提供
              </h2>
              <p className="leading-relaxed font-bold">
                当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
              </p>
              <ul className="list-disc list-inside space-y-2 pl-4 mt-3 font-bold">
                <li>法令に基づく場合</li>
                <li>人の生命、身体または財産の保護のために必要がある場合</li>
                <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
                <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-black text-red-900 mb-4 border-l-4 border-amber-600 pl-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                5. 個人情報の管理
              </h2>
              <p className="leading-relaxed font-bold">
                当社は、個人情報の正確性を保ち、これを安全に管理します。個人情報への不正アクセス、紛失、破壊、改ざん、漏洩などを防止するため、適切なセキュリティ対策を実施します。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-black text-red-900 mb-4 border-l-4 border-amber-600 pl-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                6. 個人情報の開示・訂正・削除
              </h2>
              <p className="leading-relaxed font-bold">
                お客様は、当社が保有する個人情報について、開示、訂正、削除を求めることができます。ご希望の場合は、お問い合わせフォームよりご連絡ください。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-black text-red-900 mb-4 border-l-4 border-amber-600 pl-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                7. プライバシーポリシーの変更
              </h2>
              <p className="leading-relaxed font-bold">
                当社は、法令の変更等に伴い、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、本ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-black text-red-900 mb-4 border-l-4 border-amber-600 pl-4" style={{ fontFamily: '"Shippori Mincho", serif' }}>
                8. お問い合わせ窓口
              </h2>
              <div className="bg-amber-50 rounded-2xl p-6 border-2 border-red-900/20 font-bold">
                <p className="mb-2"><strong className="text-red-900">会社名：</strong>合同会社SASAICHI</p>
                <p className="mb-2"><strong className="text-red-900">所在地：</strong>神奈川県横須賀市湘南鷹取六丁目14番13号</p>
                <p><strong className="text-red-900">お問い合わせ：</strong>本ウェブサイトのお問い合わせフォームよりご連絡ください</p>
              </div>
            </section>

            
          </div>
        </div>
      </main>
    </div>
  );
}
